import { render, staticRenderFns } from "./InstallationGuides.vue?vue&type=template&id=4492f1f2"
import script from "./InstallationGuides.vue?vue&type=script&lang=ts"
export * from "./InstallationGuides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports